<template>
	<el-dialog :visible.sync="visible" title="配置业务域名" width="782px" :before-close="cancel" ref="dialog" :close-on-click-modal="false">
		<div class="container">
			<div class="content" ref="list">
				<div class="item-box" v-for="(item, index) in businessList" :key="index">
		        	<div class="index">域名{{index + 1}}</div>
		        	<div class="item">
                        <span class="prefix">https://</span>
		            	<input type="text" class="el-input" v-model="item.domain" :ref="'input' + index" @blur="checkDomain(index)">
		            	<div class="add" @click.prevent="add" v-if="index === 0 && businessList.length !== 20"></div>
                    	<div class="del"  @click.stop="del(index)" v-if="index !== 0"></div>
                        <p class="error-info" v-if="validInfo[index]">{{errorInfo}}</p>
		        	</div>
		   	 	</div>
	   	 	</div>
	   	 	<div class="btn">
	    		<span class="btn-cancle" @click="cancel">取消</span>
	    		<span class="btn-ok" @click="submit">保存并提交</span>
			</div>
		</div>	
	</el-dialog>
</template>
<script>
import dao from '@/lib/dao';

export default {
	props:{
	    visible: {
	        type: Boolean,
	        default: true,
	    },
        info: {
            type: Object,
            default() {
                return {};
            }
        }
	},
	data() {
		return {
            errorInfo: '该域名包含非法字符，只支持英文大小写字母、数字、“:”及“-”',
            validInfo: {},
            businessList: []
		}
	},
	methods: {
		cancel() {
            this.validInfo = {};
			this.$emit('cancel');
		},
		add() {
            const modulData = {
                domain: '',
                canUpdate: true
            };
			this.$set(this.businessList, this.businessList.length, modulData);
		},
		del(index) {
            this.$delete(this.businessList, index, 1);
            this.$delete(this.validInfo, index); // 删除校验结果
		},
		submit() {
            let valid = Object.keys(this.validInfo).some(key => !!this.validInfo[key]);
			if (valid) { // 校验失败
				return;
			}
			// 校验通过
			let params = {
				appId: this.$route.params.appId,
				limitType: 0,
                business: []
			};
            let businessCur;
            businessCur = this.businessList.filter(item => item.domain !== '' && item.canUpdate === true);
            // .map(item => `https://${item}`);
            businessCur && businessCur.forEach(itemP => {
                params.business.push(itemP.domain);
            });
            Object.keys(params).forEach(key => {
                if (key !== 'appId' && key !== 'limitType') {
                    params[key] = params[key].map(item => `https://${item}`);
                }
            });
			dao.shop.modifyServerDomain(params).then(data => {
				this.$message.success('配置成功');
				this.$emit('refresh');
                this.$emit('cancel');
			}).catch(msg => {
				this.$message.error(msg);
			})
		},
        checkDomain(index) {
            this.$delete(this.validInfo, index); // 删除校验结果
            if (this.businessList && this.businessList[index] == '') {
                let valid = false;
            } else {
                let valid = !/^[0-9a-zA-Z\.\-:]+$/.test(this.businessList[index].domain) || (this.businessList[index].domain.indexOf("/") > -1);
                this.$set(this.validInfo, index, valid);
            }// true: 校验失败， false: 校验成功
	    }
    },
    mounted() {
        this.$emit('refresh', 0);
        Object.keys(this.info).forEach((key,item) => {
            if (this.info[key] === 'businessList') {
                this.info[key].forEach(subItem => {
                   subItem.domain = subItem.domain.replace(/^(https:\/\/)/, '');
                });
            }
            
        });
        this.businessList = this.info.businessList || [{domain: '', canUpdate: true}];
        this.businessList.forEach(subItem => {
            subItem.domain = subItem.domain.replace(/^(https:\/\/)/, '');
        });
    }
}
</script>
<style scoped>
	.container {
		font-size: 12px;
		position: relative;
	}
	.content {
        height: 326px;
        overflow-y: auto;
		padding: 22px;
    }
    .content::-webkit-scrollbar-track {
        background-color: #F5F5F5;
    }
    .content::-webkit-scrollbar {
        width: 4px;
        height: 10px;
        background-color: #F5F5F5;
    }
    .content::-webkit-scrollbar-thumb {
    	border-radius: 5px;
        background-color: rgba(153, 153, 153, 0.5);
        height: 10px;
    }
	.item-box {
        position: relative;
        padding-left: 47px;
    }
	.item {
        position: relative;
        margin-bottom: 15px;
    }
    .item .prefix {
        display: inline-block;
        width: 48px;
		position: absolute;
        text-align: right;
		z-index: 1;
		height: 34px;
		line-height: 34px;
		color: #5C667E;
	}
    .el-input {
        display: inline-block;
    	box-sizing: content-box;
        vertical-align: bottom;
        border: 1px solid #E0E5EC;
        height: 30px;
        line-height: 30px;
        border-radius: 2px;
        padding-right: 10px;
		padding-left: 48px;
        color: #5C667E;
        font-size: 12px;
        outline: none;
        width: 550px;
    }
    .el-input:focus{
    	border-color: #789AFF;
    }
    .index {
        position: absolute;
        left: 0;
        top: 6px;
        line-height: 22px;
        width: 40px;
        color: #5C667E;
        text-align: right;
    }
    .del {
		position: absolute;
		top: 5px;
		right: 0;
		width: 26px;
        height: 26px;
        display: inline-block;
        background: url(./../../assets/icon-popuo-done@2x.png) center center no-repeat;
        background-size: 100% 100%;
        cursor: pointer;
	}
	.add {
		position: absolute;
		top: 5px;
		right: 0;
		width: 26px;
        height: 26px;
        display: inline-block;
        background: url(./../../assets/icon-plus@2x.png) center center no-repeat;
        background-size: 100% 100%;
        cursor: pointer;
	}
    .btn {
        text-align: center;
        padding: 10px 0;
    }
    .btn-cancle {
    	padding: 10px 34px; 
    	border: 1px solid #789AFF;
		border-radius: 2px;
		width: 96px;
		font-size: 14px;
		height: 40px;
		line-height: 40px;
		color: #789AFF;
		text-align: center;
        margin-right: 10px;
        cursor: pointer;
    }
    .btn-ok {
    	padding: 10px 13px;
    	background: #789AFF;
    	border: 1px solid #789AFF;
		border-radius: 2px;
		width: 96px;
		font-size: 14px;
		height: 40px;
		line-height: 40px;
		color: #FFF;
        cursor: pointer;
    }
    .error-info {
        color: #FF7B58;
        font-size: 12px;
        line-height: 14px;
        margin-top: 6px;
    }
</style>


// WEBPACK FOOTER //
// src/components/developer/BusinessDomainSetting.vue